import React, { Component } from 'react';

class Dashboard extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        hello World
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./components/Dashboard/index.js